import { DunsStep } from "./DunsStep";
import { AccountStep } from "./AccountStep";
import { PublishStep } from "./PublishStep";
import { ApprovalStep } from "./ApprovalStep";
import { InviteStep } from "./InviteStep";
import { PLATFORMS } from "../../../../utils/constants";

export const androidSteps = { create }

function create(storeData, appInfo) {

  const steps = [];

  if(appInfo?.platformId !== PLATFORMS.CONVERTR) {
    const dunsCompleted = storeData?.dunsNumber;
    const dunsBlocked = findNotCompleted(steps);
    steps.push({
      step: steps.length + 1,
      name: 'DUNS',
      completed: dunsCompleted,
      title: 'Crie um número DUNS para sua empresa',
      content: <DunsStep.Content blocked={dunsBlocked} />,
      summary: <DunsStep.Summary />    
    });
  }

  const accountCompleted = storeData?.platforms?.android?.developerAccountName
    && storeData?.platforms?.android?.developerAccountEmail;
  const accountBlocked = findNotCompleted(steps);
  steps.push({
    step: steps.length + 1,
    name: 'Conta',
    completed: !accountBlocked && accountCompleted,
    title: 'Crie uma conta de desenvolvedor Google para sua empresa',
    content: <AccountStep.Content blocked={accountBlocked}/>,
    summary: <AccountStep.Summary blocked={accountBlocked} />
  });

  const inviteCompleted = storeData?.platforms?.android?.isInvitationSent;
  const inviteBlocked = findNotCompleted(steps);
  steps.push({
    step: steps.length + 1,
    name: 'Convite',
    completed: !inviteBlocked && inviteCompleted,
    title: 'Envie um convite de acesso à sua conta de desenvolvedor para nossa equipe',
    content: <InviteStep.Content blocked={inviteBlocked} />,
    summary: <InviteStep.Summary blocked={inviteBlocked} />
  });

  const publishingCompleted = ['pending_listing_creation','publishing', 'in_review']
    .includes(appInfo?.androidPublishStatus);
  const publishBlocked = findNotCompleted(steps);
  steps.push({
    step: steps.length + 1,
    name: 'Publicação',
    completed: !publishBlocked && publishingCompleted,
    title: 'Solicite a publicação do seu aplicativo',
    content: <PublishStep.Content blocked={publishBlocked} />,
    summary: <PublishStep.Summary blocked={publishBlocked} />
  });

  const approvalBlocked = findNotCompleted(steps);
  steps.push({
    step: steps.length + 1,
    name: 'Aprovação',
    completed: !approvalBlocked,
    title: 'Acompanhe a aprovação do seu aplicativo',
    content: <ApprovalStep.Content blocked={approvalBlocked} />,
    summary: <ApprovalStep.Summary blocked={approvalBlocked} />
  });

  return steps;
}

function findNotCompleted(steps){
  return steps.find(x => !x.completed)
}